<template>
  <div>
    <tool-bar :title="title"></tool-bar>

    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false"
    ></error-alert-item>

    <refresh-item
      :show="showRefreshItem"
      @onRefresh="onRefreshClicked"
    ></refresh-item>

    <div v-show="showUI && !showRefreshItem">
      <div v-show="needToShowCategoryDropdown" class="dropdown_container">
        <wxc-dropdown
          title="Category"
          default-item="Select"
          :config="dropdownConfig"
          :list="categories"
          :select-item="category"
          @onItemSelected="onCategorySelected"></wxc-dropdown>
      </div>

      <div v-show="needToShowBrandDropdown" class="dropdown_container">
        <wxc-dropdown
          title="Brand"
          default-item="Select"
          :config="dropdownConfig"
          :list="brands"
          :select-item="brand"
          @onItemSelected="onBrandSelected"></wxc-dropdown>
      </div>

      <div class="input_container" v-if="showBrandInput">
        <weex-text class="input_label">Brand</weex-text>
        <div class="item-price-input-container">
          <input
            :readonly="!brandEditable"
            v-bind:class="[!brandEditable ? 'uneditable' : '', 'item-price-input']"
            :value="brand"
            @input="brand=$event.target.value"
            type="text" />
        </div>
      </div>

      <div v-show="needToShowModelDropdown" class="dropdown_container">
        <wxc-dropdown
          title="Product"
          default-item="Select"
          :config="dropdownConfig"
          :list="models"
          :select-item="model"
          @onItemSelected="onModelSelected"></wxc-dropdown>
      </div>

      <div class="input_container" v-if="showModelInput">
        <weex-text class="input_label">Product</weex-text>
        <div class="item-price-input-container">
          <input
            :readonly="!modelEditable"
            v-bind:class="[!modelEditable ? 'uneditable' : '', 'item-price-input']"
            :value="model"
            @input="model=$event.target.value"
            type="text" />
        </div>
      </div>
  
      <div class="input_container" v-show="!hideProductPriceFieldDisabledBasedOnCategory">
        <weex-text class="input_label" v-if="isUsePriceForLoanAmount">Loan amount</weex-text>
        <weex-text class="input_label" v-if="!isUsePriceForLoanAmount">Product/Service Price</weex-text>
        <div class="item-price-input-container">
          <input
            :readonly="true"
            class="item-price-label-input"
            :value="rupeeSign" />
          <weex-text
            v-if="productPriceFieldDisabled"
            class="disable-item-price-input padding-top-5 padding-bottom-5">
            {{ productPrice }}
          </weex-text>
          <input
            v-else
            class="item-price-input"
            :value="productPrice"
            @input="productPrice=$event.target.value"
            type="number" />

        </div>
      </div>

      <wxc-button
        text="Continue"
        class="button_horizontal_center margin_top_40"
        type="blue"
        @wxcButtonClicked="onClickedContinue"
      ></wxc-button>
    </div>
  </div>
</template>

<script>

import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import WxcDropdown from "../../../weex-ui/packages/wxc-dropdown/index";
import EzUtils from "../../utils/EzUtils";
import ErrorAlertItem from "../layout/ErrorAlertItem";
import Loading from "../layout/Loading";
import DataSource from "../../data/DataSource";
import ToolBar from "../layout/ToolBar";
import PrefManager from "../../data/model/PrefManager";
import { RolesConstants } from "../../utils/RolesConstants";
import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
import AlertService from "../core/alert/AlertService";
import RefreshItem from "../layout/RefreshItem";
import { MessageConstants } from "../../utils/MessageConstantUtil";
import { DefaultResourceConfig } from "../../utils/ImageResourcesUtil";
import ActivityNavigator, { Activities } from "../../utils/ActivityNavigator";
import storageUtil from "../../utils/StorageUtil";

const RUPEE = "\u20B9";
const DEALER_ONBOARDING = "dealer_onboarding";
const DEALER_ONBOARDING_LOAN_AMOUNT = 1000;

export default {
  name: "LoanProductDetails",
  components: { WxcButton, WxcDropdown, ErrorAlertItem, Loading, ToolBar, RefreshItem },
  data: () => ({
    title: "Product Details",
    category: "",
    brand: "",
    model: "",
    productPrice: "",
    categories: [],
    brands: [],
    models: [],
    showRefreshItem: false,
    needToSelectCategory: true,
    needToSelectBrand: true,
    needToSelectModel: true,
    modelPriceMap: {},
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    officeIdToFetchData: -1,
    showUI: false,
    productPriceFieldDisabled: false,
    hideProductPriceFieldDisabledBasedOnCategory: false,
    brandEditable : false,
    showBrandInput : false,
    modelEditable : false,
    showModelInput : false,
    isUsePriceForLoanAmount : false,
  }),

  methods: {
    showToast(message) {
      AlertService.showToast(message);
    },

    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    onRefreshClicked() {
      this.showRefreshItem = false;
      this.getPartnerConfigOrCategories();
    },

    onCategorySelected(e) {
      this.category = e.value;

      //TODO @anish remove below hardcoded check for price
      if (this.category === "GST Payment") {
        this.productPrice = "20000";
        this.hideProductPriceFieldDisabledBasedOnCategory = true;
      } else {
        this.hideProductPriceFieldDisabledBasedOnCategory = false;
      }

      this.resetBrands();
      this.resetModels();
      if (this.category) {
        this.getBrands();
      }
    },

    onBrandSelected(e) {
      this.brand = e.value;
      this.resetModels();
      if (this.category && this.brand) {
        this.getModels();
      }
    },

    onModelSelected(e) {
      this.model = e.value;
      if (this.modelPriceMap[this.model]) {
        this.productPrice = this.modelPriceMap[this.model];
        this.productPriceFieldDisabled = true;
      } else if (this.loanAmountFromLeadDetailsIfExist) {
        this.productPrice = this.loanAmountFromLeadDetailsIfExist;
        this.productPriceFieldDisabled = true;
      } else {
        this.productPriceFieldDisabled = false;
      }
    },

    resetCategories() {
      this.needToSelectCategory = true;
      this.categories = [];
      this.category = "";
      this.resetBrands();
    },

    resetBrands() {
      this.needToSelectBrand = true;
      this.brands = [];
      this.brand = "";
      this.resetModels();
    },

    resetModels() {
      this.needToSelectModel = true;
      this.models = [];
      this.model = "";
      this.modelPriceMap = {};
    },

    onClickedContinue() {
      if (this.checkForValidation()) {
        if (this.isAgent) {
          this.validateProductWithEMIScheme();
        } else {
          this.validateProductWithPrice();
        }
      }
    },

    validateProductWithEMIScheme() {
      this.loading = true;
      DataSource.getEmiSchemes(
        -1,
        "",
        this.category,
        this.brand,
        this.model,
        this.productPrice,
        this.getOfficeId,
        ""
      )
        .then(emiSchemesResponse => {
          this.loading = false;
          if (emiSchemesResponse.errorOccurred) {
            this.showError(emiSchemesResponse.data);
          } else {
            const emiSchemes = emiSchemesResponse.data;
            if (emiSchemes && emiSchemes.length > 0) {
              LoanScopeDataHolder.setChosenEmiScheme(emiSchemes[0]);
              this.onDataValid();
            } else {
              this.showToast(MessageConstants.EMI_SCHEMES_NOT_AVAILABLE_MESSAGE);
            }
          }
        })
    },

    validateProductWithPrice() {
      this.loading = true;
      const productDetails = {
        loanId: -1,
        category: this.category,
        brand: this.brand,
        model: this.model,
        price: this.productPrice.toString().trim()
      }
      DataSource.validateProduct(productDetails)
        .then(validateProductRes => {
          this.loading = false;
          if (validateProductRes.errorOccurred) {
            this.showError(validateProductRes.data);
          } else {
            if (validateProductRes.data) {
              this.onDataValid();
            } else {
              this.showToast(MessageConstants.DETAILS_NOT_VALID)
            }
          }
        })
    },

    onDataValid() {
      LoanScopeDataHolder.setLoanAmount(this.productPrice);
      LoanScopeDataHolder.setProductCategory(this.category);
      LoanScopeDataHolder.setBrand(this.brand);
      LoanScopeDataHolder.setModel(this.model);
      ActivityNavigator.navigateTo(Activities.CLIENT_DETAILS);
    },

    checkForValidation() {
      if (this.needToSelectCategory && EzUtils.isEmpty(this.category)) {
        this.showToast(MessageConstants.SELECT_CATEGORY);
        return false;
      }
      if (this.needToSelectBrand && EzUtils.isEmpty(this.brand)) {
        this.showToast(MessageConstants.SELECT_BRAND);
        return false;
      }
      if (this.needToSelectModel && EzUtils.isEmpty(this.model)) {
        this.showToast(MessageConstants.SELECT_MODEL);
        return false;
      }
      if (EzUtils.isEmpty(this.productPrice)) {
        this.showToast(MessageConstants.ENTER_PRICE);
        return false;
      }
      if (!EzUtils.containsOnlyNumbers(this.productPrice) || parseInt(this.productPrice) <= 0) {
        this.showToast(MessageConstants.ENTER_VALID_PRICE);
        return false;
      }
      return true;
    },

    getPartnerConfigOrCategories() {
      this.showUI = false;
      this.resetCategories();
      if (EzUtils.isValidId(this.officeIdToFetchData)) {
        this.getCategories();
      } else if (this.getOfficeExternalId) {
        this.getPartnerConfig()
      }
    },

    getPartnerConfig() {
      this.loading = true;
      DataSource.getRetailerConfig({ officeExternalId: this.getOfficeExternalId })
        .then(partnerConfigRes => {
          if (partnerConfigRes.errorOccurred) {
            this.showError(partnerConfigRes.data);
            this.showRefreshItem = true;
          } else {
            this.officeIdToFetchData = partnerConfigRes.data.officeId;
            this.isUsePriceForLoanAmount = partnerConfigRes.data.usePriceForLoanAmount;
            this.getCategories();
          }
        })
    },

    getCategories() {
      this.loading = true;
      DataSource.getProductCategoriesForOffice(this.officeIdToFetchData)
        .then(categoriesResponse => {
          if (categoriesResponse.errorOccurred) {
            this.showError(categoriesResponse.data);
            this.showRefreshItem = true;
          } else {
            this.loading = false;
            this.showUI = true;
            categoriesResponse.data && categoriesResponse.data.forEach(category => {
              this.categories.push({ title: category, value: category })
            })
            if (this.categories && this.categories.length > 0) {
              this.needToSelectCategory = true;
              if (this.categories.length === 1) {
                this.category = this.categories[0].value;
              } else {
                const categoryFromLead = this.categoryFromLeadDetailsIfExists;
                if (this.isValidCategory(this.categories, categoryFromLead)) {
                  this.category = categoryFromLead;
                }
              }
            } else {
              this.needToSelectCategory = false;
              this.needToSelectBrand = false;
              this.needToSelectModel = false;
            }
          }
        })
    },

    /**
     * CREDIT-6514 changes
     * 1. Fetch brand from lead, 
     *    If exist show pre fill into input and make it uneditable <br>
     *    Else fetch it from master API 
     *      If master API data exist set it into drop down and show <br>
     *      Else show a free text input
     */
    getBrands() {
      this.showBrandInput = false;
      const brandFromLead = this.brandFromLeadDetailsIfExists;
      if (brandFromLead) {
        this.brand = brandFromLead;
        this.brandEditable = false;
        this.showBrandInput = true;
        this.needToSelectBrand = false;
        this.needToSelectModel = false;
      }else{
        this.loading = true;
        DataSource.getBrandsForOfficeAndCategory(this.officeIdToFetchData, this.category)
          .then(brandResponse => {
            if (brandResponse.errorOccurred) {
              this.showError(brandResponse.data);
              if (!this.needToShowCategoryDropdown) {
                this.showRefreshItem = true;
              }
            } else {
              this.loading = false;
              brandResponse.data && brandResponse.data.forEach(brand => {
                this.brands.push({ title: brand, value: brand });
              })
              if (this.brands && this.brands.length > 0) {
                this.needToSelectBrand = true;
                if (this.brands.length === 1) {
                  this.brand = this.brands[0].value;
                }
              } else {
                this.needToSelectBrand = false;
                this.needToSelectModel = false;
                this.brandEditable = true;
                this.showBrandInput = true;
              }
            }
          })
      }
    },

    /**
     * CREDIT-6514 changes
     * 1. Fetch model from lead, 
     *    If exist show pre fill into input and make it uneditable <br>
     *    Else fetch it from master API 
     *      If master API data exist set it into drop down and show <br>
     *      Else show a free text input
     */
    getModels() {
      this.showModelInput = false;
      const modelFromLead = this.modelFromLeadDetailsIfExists;
      if (modelFromLead) {
        this.model = modelFromLead;
        this.modelEditable = false;
        this.showModelInput = true;
        this.needToSelectModel = false;
      }else{
        this.loading = true;
        DataSource.getModelsWithDetails(
          -1,
          this.officeIdToFetchData,
          this.category,
          this.brand
        )
        .then(modelResponse => {
          if (modelResponse.errorOccurred) {
            this.showError(modelResponse.data);
            if (!this.needToShowCategoryDropdown && !this.needToShowBrandDropdown) {
              this.showRefreshItem = true;
            }
          } else {
            this.loading = false;
            modelResponse.data
            && modelResponse.data.data
            && modelResponse.data.data.forEach(modelDescription => {
              const model = modelDescription.name;
              const price = modelDescription.price;
              if (EzUtils.isAValidNumber(price)) {
                this.modelPriceMap[model] = Number(price).toFixed(0);
              }
              this.models.push({ title: model, value: model });
            })
            if (this.models && this.models.length > 0) {
              this.needToSelectModel = true;
              if (this.models.length === 1) {
                this.model = this.models[0].value
              }
            } else {
              this.needToSelectModel = false;
              this.modelEditable = true;
              this.showModelInput = true;
            }
          }
        })
      }
    },

    isValidCategory(categories, category) {
      let validCategory = false;
      category && categories && categories.forEach(categoryObject => {
        if (categoryObject && categoryObject.value === category) {
          validCategory = true;
        }
      })
      return validCategory;
    },

    isValidBrand(brands, brand) {
      let validBrand = false;
      brand && brands && brands.forEach(brandObject => {
        if (brandObject && brandObject.value === brand) {
          validBrand = true;
        }
      });
      return validBrand;
    },

    isValidModel(models, model) {
      let validModel = false;
      model && models && models.forEach(modelObject => {
        if (modelObject && modelObject.value === model) {
          validModel = true;
        }
      });
      return validModel;
    }
  },

  created() {
    if (LoanScopeDataHolder.isOnboardingLoan()) {
      this.category = DEALER_ONBOARDING;
      this.brand = DEALER_ONBOARDING;
      this.model = DEALER_ONBOARDING;
      this.productPrice = DEALER_ONBOARDING_LOAN_AMOUNT;
      this.onDataValid();
    } else {
      this.officeIdToFetchData = this.getOfficeId;
      this.productPrice = this.loanAmountFromLeadDetailsIfExist;
      if (this.productPrice) {
        this.productPriceFieldDisabled = true;
      }
      this.getPartnerConfigOrCategories();
    }
  },

  computed: {
    rupeeSign() {
      return RUPEE;
    },

    dropdownConfig() {
      return DefaultResourceConfig.DROP_DOWN;
    },

    needToShowCategoryDropdown() {
      return this.categories && this.categories.length > 1;
    },

    needToShowBrandDropdown() {
      return this.brands && this.brands.length > 1;
    },

    needToShowModelDropdown() {
      return this.models && this.models.length > 1;
    },

    getOfficeId() {
      if (this.isAgent) {
        return PrefManager.getUserOfficeId();
      }

      if (LoanScopeDataHolder.getMerchantID()) {
        return -1;
      }

      const leadDetails = LoanScopeDataHolder.getLeadDetails();
      if (leadDetails && EzUtils.isValidId(leadDetails.office_id)) {
        return leadDetails.office_id;
      }
      return -1;
    },

    isAgent() {
      return PrefManager.doesUserHasRole(RolesConstants.AGENT);
    },

    getOfficeExternalId() {
      return LoanScopeDataHolder.getMerchantID();
    },

    loanAmountFromLeadDetailsIfExist() {
      const leadDetails = LoanScopeDataHolder.getLeadDetails();
      const leadDetailsData = leadDetails && leadDetails.data
        ? EzUtils.convertToJSONObjectIfString(leadDetails.data)
        : {};

      const loanAmount = EzUtils.isAValidNumber(leadDetailsData.loanAmount)
        ? Number(leadDetailsData.loanAmount).toFixed(0).toString()
        : (EzUtils.isAValidNumber(leadDetailsData.productPrice)
            ? Number(leadDetailsData.productPrice).toFixed(0).toString()
            : 0
        );

      return loanAmount > 0 ? loanAmount : "";
    },

    categoryFromLeadDetailsIfExists() {
      const leadDetails = LoanScopeDataHolder.getLeadDetails();
      return leadDetails && leadDetails.category ? leadDetails.category : "";
    },

    brandFromLeadDetailsIfExists() {
      const leadDetails = LoanScopeDataHolder.getLeadDetails();
      return leadDetails && leadDetails.brand ? leadDetails.brand : "";
    },

    modelFromLeadDetailsIfExists() {
      const leadDetails = LoanScopeDataHolder.getLeadDetails();
      return leadDetails && leadDetails.model ? leadDetails.model : "";
    },
  }
}
</script>

<style scoped>
.uneditable{
    cursor: not-allowed;
    background: #ececec;
}
</style>

<style
  scoped
  src="../../assets/style/base.css"></style>
